export const detNotify = () => undefined;

export const resetNotify = () => undefined;
